import React from 'react';
import { useTranslation } from 'react-i18next';

import LoadingButton from '../../common/LoadingButton';
import { ErrorAlert } from './ErrorAlert';
import { PetCloudInput } from '../../common/petCloud';

import { useVerifyScreenForm } from './hooks/useVerifyScreenForm';

import styles from './VerifyScreen.module.css';

const VerifyScreen = ({
  email = '',
  onVerify = () => { },
  setCurrentStep = () => { },
  showNoMatchError = false,
  showSkipButton = false,
  verifyingCustomer = false,
}) => {
  const { t } = useTranslation('petDemos');

  const {
    firstName,
    firstNameError,
    firstNamePlaceholder,
    handleFirstNameChange,
    handleLastNameChange,
    handleOnBlurFirstName,
    handleOnBlurLastName,
    handleOnBlurZipCode,
    handleSkip,
    handleSubmit,
    handleVerifyMouseDown,
    handleZipCodeChange,
    lastName,
    lastNameError,
    lastNamePlaceholder,
    noErrors,
    ZIP_CODE_MAX_LENGTH,
    zipCode,
    zipCodeError,
  } = useVerifyScreenForm({ email, onVerify, setCurrentStep });

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <h1 className={styles.verifyTitle}>
          {t('certificateLinking.verifyDetails.title')}
        </h1>

        <p className={styles.description}>
          {t('certificateLinking.verifyDetails.description')}
        </p>
      </div>

      {showNoMatchError && (
        <div className={styles.alertContainer}>
          <ErrorAlert />
        </div>
      )}

      <form className={styles.inputContainer} onSubmit={handleSubmit}>
        <PetCloudInput
          className={styles.emailInput}
          disabled
          inputName="email"
          title={t('certificateLinking.verifyDetails.email')}
          value={email}
        />

        <PetCloudInput
          error={firstNameError}
          inputName="firstName"
          onBlur={handleOnBlurFirstName}
          onChange={handleFirstNameChange}
          placeholder={firstNamePlaceholder}
          title={t('certificateLinking.verifyDetails.firstName')}
          value={firstName}
        />

        <PetCloudInput
          error={lastNameError}
          inputName="lastName"
          onBlur={handleOnBlurLastName}
          onChange={handleLastNameChange}
          placeholder={lastNamePlaceholder}
          title={t('certificateLinking.verifyDetails.lastName')}
          value={lastName}
        />

        <PetCloudInput
          error={zipCodeError}
          inputName="zipCode"
          maxLength={ZIP_CODE_MAX_LENGTH}
          onBlur={handleOnBlurZipCode}
          onChange={handleZipCodeChange}
          placeholder={t('certificateLinking.verifyDetails.zipCodePlaceholder')}
          title={t('certificateLinking.verifyDetails.zipCode')}
          value={zipCode}
        />

        <LoadingButton
          className={styles.verifyButton}
          disabled={verifyingCustomer || !noErrors}
          loading={verifyingCustomer}
          onMouseDown={handleVerifyMouseDown}
          text={t('certificateLinking.verifyDetails.verify')}
        />

        {showSkipButton && (
          <button
            className={styles.skipButton}
            onClick={handleSkip}
            type="button"
          >
            {t('certificateLinking.verifyDetails.skip')}
          </button>
        )}
      </form>
    </div>
  );
};

export { VerifyScreen };
